import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
// Inject preconnect/dns-prefetch hints to speed up font + image CDN handshakes on mobile.
function addPreconnect(href: string, crossOrigin?: boolean) {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}
addPreconnect('https://fonts.googleapis.com');
addPreconnect('https://fonts.gstatic.com', true);
addPreconnect('https://cdn.magicpatterns.com', true);
addPreconnect('https://connect.facebook.net', true);
// Initialize Meta Pixel and fire PageView on app load
initMetaPixel();
trackPageView();
render(<App data-id="element-547" />, document.getElementById('root'));